<template>
    <h2 class="detail_title ab">{{ title }}</h2>
</template>
  
<script>
export default {
    props: ['title', 'width']
}
</script>
  <style lang="css" scoped>
.detail_title {
  border-left: 5px solid  #4FCCD4;
  font-size: 16px;

  padding-left: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/SidebarTitle.vue